import React from 'react';
import SaleBarWrapper from 'components/SaleBarWrapper';
import { useSubscriptionsAndAllowedFeaturesContext } from 'contexts/SubscriptionsAndAllowedFeaturesContext/SubscriptionsAndAllowedFeaturesContext';
import PoorStandingBanner from './components/PoorStandingBanner/PoorStandingBanner';
import PlanPausedBanner from './components/PlanPausedBanner/PlanPausedBanner';

export enum BannersType {
    PoorStanding = 'PoorStanding',
    PlanPaused = 'PlanPaused',
    Fallback = 'Fallback',
}

export const getBanners = ({
    isPlanPaused,
    isPoorStanding,
}: {
    isPlanPaused: boolean;
    isPoorStanding: boolean;
}) => {
    let activeBanner = BannersType.Fallback;

    if (isPoorStanding) {
        activeBanner = BannersType.PoorStanding;
    } else if (isPlanPaused) {
        activeBanner = BannersType.PlanPaused;
    }

    return {
        activeBanner,
    };
};

export const Banners = () => {
    const { isPlanPaused, isPoorStanding } =
        useSubscriptionsAndAllowedFeaturesContext();

    const { activeBanner } = getBanners({ isPlanPaused, isPoorStanding });

    return (
        <>
            {activeBanner === BannersType.PoorStanding && (
                <PoorStandingBanner />
            )}
            {activeBanner === BannersType.PlanPaused && <PlanPausedBanner />}
            {activeBanner === BannersType.Fallback && <SaleBarWrapper />}
        </>
    );
};
